import { signal } from '@angular/core';
import { noop, Observable, of } from 'rxjs';
import { Concept, Device } from '@iot-platform/models/i4b';
import { cloneDeep } from 'lodash';

const devicesFacadeMock = {
  canCreate: signal(true),
  canRead: signal(true),
  canUpdate: signal(true),
  canDelete: signal(true),
  canReadSite: signal(true),
  canReadAuditTrail: signal(true),
  canReadEvent: signal(true),
  canUpdateEvent: signal(true),
  canReadDataGuard: signal(true),
  canUseFunnel: signal(true),
  userPermissions: signal([
    { key: 'canUpdateDevice', value: true },
    { key: 'canDeleteDevice', value: true },
    { key: 'canUpdateEvent', value: true },
    { key: 'canReadEvent', value: true }
  ]),
  deviceTags: signal([]),
  deviceTagsLoaded: signal(false),
  deviceTagsLoading: signal(false),
  deviceComments: signal([]),
  deviceCommentsLoading: signal(false),
  commentsFilters: signal([
    { name: Concept.DEVICE, checked: true, disabled: false },
    { name: Concept.SITE, checked: false, disabled: false }
  ]),
  configurationUrl: signal(undefined),

  concept: 'devices',
  all: signal([]),
  all$: of([]),
  loaded: signal(false),
  loaded$: of(false),
  loading: signal(false),
  loading$: of(false),
  selectedEntity: signal(null),
  selectedEntity$: of(null) as Observable<Device | null>,
  gridConfiguration$: of({ sortedGridsWithoutAppDefault: [], currentGrid: null, isGridsLoading: false }),
  gridConfiguration: signal({ sortedGridsWithoutAppDefault: [], currentGrid: null, isGridsLoading: false }),
  grids$: of([]),
  favoriteViewConfiguration$: of({
    sortedFavoriteViews: [],
    currentFavoriteView: null,
    isFavoriteViewsLoading: false
  }),
  favoriteViewConfiguration: signal({
    sortedFavoriteViews: [],
    currentFavoriteView: null,
    isFavoriteViewsLoading: false
  }),
  filters: signal([]),
  selectedItemInGrid: signal(null),
  filters$: of([]),
  pagination: signal({ limit: 100 }),
  deviceDataGuardStatus: signal(null),
  progress: signal<number | null>(null),
  setFilters: () => noop(),
  initDeviceOverviewPage: () => noop(),
  loadDeviceById: () => noop(),
  loadDeviceTags: () => noop(),
  updateDevice: () => noop(),
  activateDevice: () => noop(),
  deleteDevice: () => noop(),
  updateDeviceTags: () => noop(),
  bulkOperationOnTag: () => noop(),
  sendCommand: () => noop(),
  bulkSendCommand: () => noop(),
  moveOneDevice: () => noop(),
  moveManyDevices: () => noop(),
  resetDevice: () => noop(),
  loadComments: () => noop(),
  addComment: () => noop(),
  editComment: () => noop(),
  deleteComment: () => noop(),
  reloadGrid: () => noop(),
  updateDeviceInCurrentGrid: () => noop(),
  loadDeviceSilently: () => noop(),
  loadDataGuardStatus: () => noop()
};

export function createDevicesFacadeMock() {
  return {
    ...cloneDeep(devicesFacadeMock),
    setFilters: jasmine.createSpy('setFilters'),
    initDeviceOverviewPage: jasmine.createSpy('initDeviceOverviewPage'),
    loadDeviceById: jasmine.createSpy('loadDeviceById'),
    loadDeviceTags: jasmine.createSpy('loadDeviceTags'),
    updateDevice: jasmine.createSpy('updateDevice'),
    activateDevice: jasmine.createSpy('activateDevice'),
    deleteDevice: jasmine.createSpy('deleteDevice'),
    updateDeviceTags: jasmine.createSpy('updateDeviceTags'),
    bulkOperationOnTag: jasmine.createSpy('bulkOperationOnTag'),
    sendCommand: jasmine.createSpy('sendCommand'),
    bulkSendCommand: jasmine.createSpy('bulkSendCommand'),
    moveOneDevice: jasmine.createSpy('moveOneDevice'),
    moveManyDevices: jasmine.createSpy('moveManyDevices'),
    moveDevices: jasmine.createSpy('moveDevices'),
    replaceDevice: jasmine.createSpy('replaceDevice'),
    resetDevice: jasmine.createSpy('resetDevice'),
    loadComments: jasmine.createSpy('loadComments'),
    addComment: jasmine.createSpy('addComment'),
    editComment: jasmine.createSpy('editComment'),
    deleteComment: jasmine.createSpy('deleteComment'),
    reloadGrid: jasmine.createSpy('reloadGrid'),
    updateDeviceInCurrentGrid: jasmine.createSpy('updateDeviceInCurrentGrid'),
    loadDeviceSilently: jasmine.createSpy('loadDeviceSilently'),
    loadDataGuardStatus: jasmine.createSpy('loadDataGuardStatus')
  };
}
